export default __webpack_public_path__ + "static/media/Maidenhair-Fern_L2.9a17681f.png";